/**
 * EEO (Equal Employment Opportunity) reference data
 * Official EEOC categories for compliance reporting
 */
import { z } from "zod";
// ===== EEO ETHNICITY =====
export const EEO_ETHNICITY_OPTIONS = [
    { value: "HISPANIC_LATINO", label: "Hispanic or Latino" },
    { value: "WHITE", label: "White (Not Hispanic or Latino)" },
    { value: "BLACK_AFRICAN_AMERICAN", label: "Black or African American (Not Hispanic or Latino)" },
    { value: "NATIVE_HAWAIIAN_PACIFIC_ISLANDER", label: "Native Hawaiian or Other Pacific Islander (Not Hispanic or Latino)" },
    { value: "ASIAN", label: "Asian (Not Hispanic or Latino)" },
    { value: "AMERICAN_INDIAN_ALASKA_NATIVE", label: "American Indian or Alaska Native (Not Hispanic or Latino)" },
    { value: "TWO_OR_MORE_RACES", label: "Two or More Races (Not Hispanic or Latino)" },
    { value: "DECLINE_TO_ANSWER", label: "Decline to Answer" },
];
export const EEO_ETHNICITY_VALUES = EEO_ETHNICITY_OPTIONS.map((o) => o.value);
export const EeoEthnicitySchema = z.enum(EEO_ETHNICITY_VALUES);
// ===== EEO GENDER =====
export const EEO_GENDER_OPTIONS = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    { value: "DECLINE_TO_ANSWER", label: "Decline to Answer" },
];
export const EEO_GENDER_VALUES = EEO_GENDER_OPTIONS.map((o) => o.value);
export const EeoGenderSchema = z.enum(EEO_GENDER_VALUES);
// ===== EEO JOB CLASSIFICATION =====
export const EEO_CLASSIFICATION_OPTIONS = [
    { value: "EXECUTIVE_SENIOR_LEVEL", label: "Executive/Senior Level Officials and Managers" },
    { value: "FIRST_MID_LEVEL", label: "First/Mid-Level Officials and Managers" },
    { value: "PROFESSIONALS", label: "Professionals" },
    { value: "TECHNICIANS", label: "Technicians" },
    { value: "SALES_WORKERS", label: "Sales Workers" },
    { value: "ADMINISTRATIVE_SUPPORT", label: "Administrative Support Workers" },
    { value: "CRAFT_WORKERS", label: "Craft Workers" },
    { value: "OPERATIVES", label: "Operatives" },
    { value: "LABORERS_HELPERS", label: "Laborers and Helpers" },
    { value: "SERVICE_WORKERS", label: "Service Workers" },
    { value: "DECLINE_TO_ANSWER", label: "Decline to Answer" },
];
export const EEO_CLASSIFICATION_VALUES = EEO_CLASSIFICATION_OPTIONS.map((o) => o.value);
export const EeoClassificationSchema = z.enum(EEO_CLASSIFICATION_VALUES);
